import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import type { Schema } from "../../amplify/data/resource";
import { generateClient } from "aws-amplify/data";
import "./EditableField.css";
import { GoPencil } from "react-icons/go";

const client = generateClient<Schema>();

export default function EditableField(props) {
  const [showMore, setShowMore] = useState(false);
  const [savedSentiment, setSavedSentiment] = useState(props ? props.sentiment : null);
  const [savedCustomContent, setSavedCustomContent] = useState(props ? props.editableContent : null);
  const [editMode, setEditMode] = useState(false);
  const [newSentiment, setNewSentiment] = useState(savedSentiment);
  const location = useLocation();

  if (!props) {
    return null;
  }

  const {
    category,
    content,
    editableContent,
    dashboardType,
  } = props;

  const isPrStrategies = dashboardType === 'PrStrategies'

  const handleModelChange = async (model, data) => {
    if (model === client.models.PrStrategies) {
      await model.update(data);
    } else {
      await model.create(data);
    }
    setSavedSentiment(data.sentiment);
  };

  const handleEdit = async () => {
    const data = {
      date: new Date().toISOString(),
      enteredBy: "Developer entry", // to do: pull auth user data when sso is set up
      category: category,
      sentiment: newSentiment,
      description: content,
    };

    if (dashboardType === "GrStrategies") {
      data.statementOfStrategy = savedCustomContent || "";
      await handleModelChange(client.models.GrStrategies, data);
    } else if (dashboardType === "GrActivities") {
      data.additionalDescription = savedCustomContent || "";
      await handleModelChange(client.models.GrActivities, data);
    } else if (dashboardType === "PrStrategies") {
      data.id = props.id;
      await handleModelChange(client.models.PrStrategies, data);
    }

    setEditMode(!editMode);
  };

    const handleSentimentChange = (newSentiment) => {
      setNewSentiment(newSentiment);
    };

    const handleCancel = () => {
      setNewSentiment(savedSentiment);
      setSavedCustomContent(editableContent);
      setEditMode(false);
    };


  return (
    <div className={`editable-field ${savedSentiment?.toLowerCase()}`}>
      {!editMode ? (
        <p className="sentiment">{savedSentiment}</p>
      ) : (
        <select
          defaultValue={savedSentiment}
          onChange={(e) => handleSentimentChange(e.target.value)}
        >
          <option value="Positive">Positive</option>
          <option value="Neutral">Neutral</option>
          <option value="Negative">Negative</option>
        </select>
      )}
      <button className="edit" onClick={() => setEditMode(!editMode)}>
        {!editMode && <GoPencil />}
      </button>
      <h3>{category}</h3>
      <p>
        {showMore ? content : `${content?.substring(0, 200)}`}
        {!showMore && content?.length > 200 ? "..." : ""}
        {content?.length > 200 && (
          <button className="link" onClick={() => setShowMore(!showMore)}>
            {!showMore ? "More" : "Less"}
          </button>
        )}
      </p>
      {location.pathname === "/gr-strategies" && !isPrStrategies && (
        <div>
          {!editMode ? (
            <p>{savedCustomContent}</p>
          ) : (
            <textarea
              rows={5}
              value={savedCustomContent}
              onChange={(e) => setSavedCustomContent(e.target.value)}
            />
          )}
        </div>
      )}
      {editMode && (
        <div style={{ textAlign: "center", paddingTop: "15px", fontSize: "1rem" }}>
          <button className="cancel-btn" onClick={handleCancel}>Cancel</button>
          <button className="save-btn" onClick={handleEdit}>Save</button>
        </div>
      )}
    </div>
  );
}